<template>
  <div class="">
    ddd
<!--    <div-->
<!--        class="kt-grid kt-grid&#45;&#45;hor kt-grid&#45;&#45;root kt-login kt-login&#45;&#45;v1"-->
<!--        id="kt_login"-->
<!--    >-->
<!--      <div-->
<!--          class="kt-grid__item kt-grid__item&#45;&#45;fluid kt-grid kt-grid&#45;&#45;desktop kt-grid&#45;&#45;ver-desktop kt-grid&#45;&#45;hor-tablet-and-mobile"-->
<!--      >-->
<!--        &lt;!&ndash;begin::Aside&ndash;&gt;-->
<!--        <div-->
<!--            class="kt-grid__item kt-grid__item&#45;&#45;order-tablet-and-mobile-2 kt-grid kt-grid&#45;&#45;hor kt-login__aside"-->
<!--            :style="{ backgroundImage: `url(${backgroundImage})` }"-->
<!--        >-->
<!--          <div class="kt-grid__item">-->
<!--            <a href="#" class="kt-login__logo">-->
<!--              <img src="@/assets/logo.png" />-->
<!--            </a>-->
<!--          </div>-->
<!--          <div class="kt-grid__item kt-grid__item&#45;&#45;fluid kt-grid kt-grid&#45;&#45;ver">-->
<!--            <div class="kt-grid__item kt-grid__item&#45;&#45;middle">-->
<!--              <h3 class="kt-login__title">Welcome to Metronic!</h3>-->
<!--              <h4 class="kt-login__subtitle">-->
<!--                The ultimate Bootstrap &amp; Angular 6 admin theme framework for-->
<!--                next generation web apps.-->
<!--              </h4>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="kt-grid__item">-->
<!--            <div class="kt-login__info">-->
<!--              <div class="kt-login__copyright">-->
<!--                © 2020 Metronic-->
<!--              </div>-->
<!--              <div class="kt-login__menu">-->
<!--                <a href="#" class="kt-link">Privacy</a>-->
<!--                <a href="#" class="kt-link">Legal</a>-->
<!--                <a href="#" class="kt-link">Contact</a>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        &lt;!&ndash;begin::Aside&ndash;&gt;-->

<!--        &lt;!&ndash;begin::Content&ndash;&gt;-->
<!--        <div-->
<!--            class="kt-grid__item kt-grid__item&#45;&#45;fluid kt-grid__item&#45;&#45;order-tablet-and-mobile-1 kt-login__wrapper"-->
<!--        >-->
<!--          <router-view></router-view>-->
<!--        </div>-->
<!--        &lt;!&ndash;end::Content&ndash;&gt;-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
//@import "@/assets/sass/pages/login/login-1.scss";
</style>

<script>
import { mapState } from "vuex";

export default {
  name: "auth",
  methods: {},
  computed: {
    ...mapState({
      // errors: state => state.auth.errors
    }),
    // backgroundImage() {
    //   return process.env.BASE_URL + "assets/media/bg-4.jpg";
    // }
  }
};
</script>
